<template>
  <div class="home">
  
    <img style="max-width: 100%;max-height: 100%;" :src="GLOBAL.imgserve+'/home.png'" alt="">
    
  </div>
</template>

<script>

// @ is an alias to /src

export default {
  name: 'Home',

 methods: {
    goPage(pagePath) {
      console.log(pagePath);
      this.$router.push(pagePath).catch((err) => {});
    },
  },


}

</script>


<style >
  
.home{
  width: 100%;
  height: 100%;
  overflow:auto;
  display: flex;
  justify-content: center;
  align-items: center;
}


</style>